var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeMiterlimit: 10,
    viewBox: "0 0 542 790",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m118.553 1389.73h474.953v436.104h-474.953z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.13999 0 0 1.8099 -134.72 -2515.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m118.553 1389.73h474.953v436.104h-474.953z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m531.604 203.042c0 69.322-56.197 125.518-125.518 125.518",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 9.61,
    transform: "matrix(2.6455386 -1.66633122 2.6455386 1.66633122 -1731.556072 1946.060588)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -23.996,
    r: 23.996,
    transform: "matrix(3.74135334 0 0 -2.3565479 301.755051 1705.305702)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -14.767,
    rx: 14.767,
    ry: 14.767,
    transform: "matrix(-3.74135334 0 0 2.3565479 122.197895 1613.945256)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -38.762,
    rx: 38.763,
    ry: 38.762,
    transform: "matrix(0 -2.3565479 -3.74135334 0 446.779244 1579.153589)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -9.23,
    rx: 9.229,
    ry: 9.23,
    transform: "matrix(3.74135334 0 0 -2.3565479 301.750859 1600.901972)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.245c9464f385c061bd3b393311cf10da.svg";
export { ForwardRef as ReactComponent };